import { Box, Card, Flex, Group, ScrollArea, Select, Stack, Text } from "@mantine/core";
import { DateTime } from "luxon";
import { CALENDAR_DATE_TYPES } from "../../../../constants/calendarConstants";
import { COLORS } from "../../../../constants/colorConstants";
import { getEntryById } from "../../../../utils/objectUtils";
import { useCreateFormContext } from "../createFormContext";
import { splitItemsIntoColumns } from "../utils/splitItemsIntoColumns";

export default function CreateFormDateSettingsCard() {
  const form = useCreateFormContext();
  const dateSettings = form.getValues().dateSettings;

  const data = [
    {
      value: CALENDAR_DATE_TYPES.REGULAR.id,
      label: CALENDAR_DATE_TYPES.REGULAR.label,
    },
    {
      value: CALENDAR_DATE_TYPES.HOLIDAY.id,
      label: CALENDAR_DATE_TYPES.HOLIDAY.label,
    },
    {
      value: CALENDAR_DATE_TYPES.INSET.id,
      label: CALENDAR_DATE_TYPES.INSET.label,
    },
  ];

  const columns = splitItemsIntoColumns({ items: dateSettings });

  return (
    <Card shadow="xs" p="md" radius="lg" miw={520} withBorder bg={COLORS.WHEAT} c={COLORS.DARK_BROWN}>
      <ScrollArea type="hidden" style={{ height: 520 }}>
        <Flex gap="md">
          {columns.map((column, columnIndex) => (
            <Stack gap="xs" key={`column-${columnIndex}`}>
              {column.map(({ item, originalIndex }) => (
                <Group key={item.date}>
                  <Text w={24} fw={700}>
                    {originalIndex + 1}
                  </Text>
                  <Text w={120}>{DateTime.fromISO(item?.date).toFormat("dd/MM/yyyy ccc")}</Text>
                  <DateSettingsInput data={data} index={originalIndex} />
                </Group>
              ))}
            </Stack>
          ))}
        </Flex>
      </ScrollArea>
    </Card>
  );
}

function DateSettingsInput({ data, index }) {
  const form = useCreateFormContext();

  const inputProps = form.getInputProps(`dateSettings.${index}.type`, { type: "select" });
  const calendarDateType = getEntryById(CALENDAR_DATE_TYPES, inputProps.defaultValue);
  const color = calendarDateType.color || "#FFFFFF";

  return (
    <Select
      allowDeselect={false}
      radius="md"
      w={120}
      checkIconPosition="right"
      comboboxProps={{ transitionProps: { transition: "pop", duration: 200 } }}
      leftSection={
        <Box
          style={{
            width: 16,
            height: 16,
            borderRadius: "50%",
            backgroundColor: color,
            border: "1px solid black",
          }}
        />
      }
      rightSection={<></>}
      data={data}
      key={form.key(`dateSettings.${index}.type`)}
      {...form.getInputProps(`dateSettings.${index}.type`, {
        type: "select",
      })}
    />
  );
}
